<template>
  <div class="index-bar-body">
    <div class="list-parent" ref="body-view">
      <div
        class="item-list"
        v-for="(item, index) in dataJson"
        :ref="'item-' + index"
        :key="index"
      >
        <div class="item-list-index">
          <img
            v-if="item.key === 'HOT'"
            src="../assets/flights/i_icon_hot_26px_@2x.m.png"
            class="margin-left"
            style="width: 1rem; height: 1rem"
          />
          <div class="margin-left">
            {{ item.key === 'HOT' ? item.str : item.key }}
          </div>
        </div>
        <div class="item-list-div">
          <div
            class="the-index-bar-item-div"
            v-for="(itemChild, indexChild) in item.value"
            :key="indexChild"
            @click="selectCity(itemChild.areaShortName, itemChild.iataCode)"
          >
            {{ itemChild.areaShortName }}
          </div>
        </div>
      </div>
    </div>
    <div class="index-parent">
      <div
        class="index-list-div"
        v-for="(item, index) in dataJson"
        :key="index"
      >
        <div
          :class="{ 'index-div': true, 'now-show': activeIndex === index }"
          @click="setScroll(index)"
        >
          {{ item.key }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'jlkj-index-bar',
  props: {
    dataJson: {
      type: Array,
    },
  },
  data() {
    return {
      activeIndex: 0,
      offsetTopGroup: [],
    };
  },
  watch: {
    dataJson: function () {
      this.init();
    },
  },
  mounted() {
    this.$refs['body-view'].addEventListener('scroll', this.handleScroll, true);
    this.init();
  },
  methods: {
    init() {
      this.dataJson.forEach((_none, index) => {
        this.offsetTopGroup.push(this.$refs[`item-${index}`]?.[0].offsetTop);
      });
    },
    handleScroll(e) {
      const index = this.offsetTopGroup.findIndex(
        (offsetTop) => offsetTop > e.target.scrollTop,
      );
      if (index !== -1 && !isNaN(index)) {
        this.activeIndex = index - 1;
      }
    },
    setScroll: function (index) {
      this.activeIndex = index;
      this.$refs[`item-${index}`][0]?.scrollIntoView();
    },
    selectCity: function (string, code) {
      this.$emit('changeCityBySon', string, code);
      this.searchInputValue = '';
    },
  },
};
</script>
<style scoped>
.index-bar-body {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 100%;
  position: relative;
  background: #ffffff;
}
.list-parent {
  width: 100%;
  box-sizing: border-box;
  padding-left: 1em;
  padding-right: 2.5em;
  overflow-y: scroll;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.index-parent {
  width: 2.5em;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
}
.index-parent > div {
  margin: 0 auto;
  width: 2.5em;
  text-align: center;
}
.index-parent > div:first-child {
  margin: 0;
}
.item-list {
  width: 100%;
}
.item-list-index {
  width: 100%;
  display: flex;
  justify-content: start;
  font-size: 15px;
  font-weight: 500;
  color: #2e3033;
  margin-top: 10px;
}
.item-list-div {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.the-index-bar-item-div {
  width: calc(100% / 4 - 6px);
  height: 40px;
  margin: 10px 3px 0 3px;
  background: #f7f8fa;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: #2e3033;
  text-align: center;
}
.index-list-div {
  width: 100%;
}
.index-div {
  color: #8a8f99;
  margin-bottom: 0.3rem;
  font-size: small;
}
.now-show {
  color: #3377ff;
}
.margin-left {
  margin-left: 0.5rem;
}
</style>
